import {  FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";
import filterbyfields from '../../config/filterbyfields';

const options = Object.keys(filterbyfields).map(key => {
    return {
        value: key,
        text: filterbyfields[key]
    }
});

function FilterBySelect({
    value, 
    onChange,
    size,
    label="Filter by", 
    disabled=false, 
    helperText="",
    error=false,
    displayEmpty=true,
    placeholder="",
    required=true
}){
    
    return<FormControl sx={{minWidth: 150}} fullWidth size="small">
        <InputLabel required={required} shrink={(displayEmpty && !!placeholder) || (displayEmpty && !!value)} error={error} >{label} </InputLabel>
        <Select 
            required={required}
            displayEmpty={displayEmpty}
            error={error}
            disabled={disabled}
            size={size}
            fullWidth
            value={value}
            label={label} 
            onChange={(e) => {onChange(e.target.value)}} 
            renderValue={v => v ? options.find(o => o.value === v).text : placeholder}

        >
            {options.map(o => { 
                return <MenuItem value={o.value} key={o.value}>{o.text}</MenuItem>            
            })}

        </Select>

        {helperText && <FormHelperText error={error}>{helperText}</FormHelperText> }
    </FormControl>
}
export default FilterBySelect;